(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["calma-express-checkout"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-express-checkout]');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('form');
    if (!form) return;
    if (!form.querySelector('input[name="return_to"]')) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      input.value = '/checkout';
      form.appendChild(input);
    }
    form.submit();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["calma-klarna"] && !Shopify.designMode) return;
  try {
    (function(){var c=document.querySelectorAll('.glory-inst');if(!c.length)return;document.addEventListener('variant:changed',function(e){var v=e.detail&&e.detail.variant;if(!v||!v.price)return;for(var i=0;i<c.length;i++){var o=c[i];if(v.price<2000){o.style.display='none';continue}o.style.display='flex';var n=parseInt(o.dataset.n,10)||3,el=o.querySelector('[data-inst-v]');if(el){var amt=Math.floor(v.price/n);if(window.Shopify&&Shopify.formatMoney){el.innerHTML=Shopify.formatMoney(amt,o.dataset.moneyFormat||"${{amount}}")}else{var loc=document.documentElement.lang||'es-ES';el.textContent=new Intl.NumberFormat(loc,{style:'currency',currency:o.dataset.currency||'EUR'}).format(amt/100)}}}});})();
  } catch(e) { console.error(e); }
})();

})();
